import React from 'react';
import cn from 'bem-cn';

import { Icon } from '../../../UI';

import { LikeProps } from './Like.types';

import './Like.scss';

const b = cn('like');

export const Like: React.FC<LikeProps> = ({
    count,
    isLiked = false,
    onClick,
    className,
    isEditorial,
    size = 'normal',
}) => {
    const handleClick = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onClick?.();
    };

    return (
        <div className={b('wrapper')}>
            <button
                className={b({ liked: isLiked, editorial: isEditorial, size }).mix(className)}
                onClick={handleClick}
                type="button"
                aria-label={isLiked ? 'Убрать лайк' : 'Поставить лайк'}
            >
                {Boolean(count) && <span className={b('count')}>{count}</span>}
                <Icon
                    name={isLiked ? 'heartFilled' : 'heart'}
                    fillColor={isLiked ? '#f55' : 'currentColor'}
                    className={b('heart', { liked: isLiked })}
                />
            </button>
        </div>
    );
};
